"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.997 10.499C18.997 5.812 15.185 2 10.5 2 5.812 2 2 5.812 2 10.499c0 4.686 3.812 8.498 8.499 8.498 2.172 0 4.158-.82 5.662-2.166l6.036 6.03a.471.471 0 0 0 .665 0 .477.477 0 0 0 0-.67l-6.034-6.027a8.465 8.465 0 0 0 2.17-5.665ZM3 10.499c0-4.136 3.363-7.5 7.499-7.5 4.136 0 7.498 3.364 7.498 7.5 0 4.135-3.362 7.498-7.498 7.498s-7.5-3.363-7.5-7.498Zm7.998-4a.5.5 0 1 0-1 0V10H6.5a.5.5 0 0 0 0 1H10v3.5a.5.5 0 0 0 1 0V11h3.499a.5.5 0 1 0 0-1h-3.5V6.5Z",
    clipRule: "evenodd"
  })]
});